var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sopBoard",
      staticClass: "sopBoard",
      staticStyle: { position: "relative" }
    },
    [
      _c(
        "div",
        {
          staticClass: "sop-expand",
          staticStyle: { "z-index": "1000" },
          on: { click: _vm.handleUnfold }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.isUnfold ? _vm.$t("Sop.PackUp") : _vm.$t("Sop.Unfold"))
            )
          ]),
          !_vm.isUnfold
            ? _c("i", { staticClass: "el-icon-arrow-down" })
            : _c("i", { staticClass: "el-icon-arrow-up" })
        ]
      ),
      _c(
        "div",
        { staticClass: "sop-tab", class: { mask: _vm.showLayer } },
        [
          _c(
            "el-tabs",
            {
              class: { isUnfold: !_vm.isUnfold },
              attrs: { lazy: true },
              on: { "tab-click": _vm.getNodeInfo },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.businessTypes, function(item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.name,
                  staticClass: "tab-pane-wrapper",
                  attrs: {
                    label:
                      item.label + " (" + (item.count ? item.count : 0) + ")",
                    name: item.name
                  }
                },
                [
                  _vm.isUnfold && _vm.rowDatas.length > 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "sop-wrapper" },
                          [
                            _vm._l(_vm.rowDatas, function(rowData, index) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "tab-guide-wrapper",
                                    class: { flexend: !rowData.isOdd }
                                  },
                                  _vm._l(rowData.data, function(item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.code,
                                        staticClass: "tab-guide",
                                        on: {
                                          click: function($event) {
                                            return _vm.jumpSopNodeDetail(
                                              item.code,
                                              "",
                                              item.name,
                                              "",
                                              item.disabled,
                                              item.subNodes
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "el-popover",
                                          {
                                            attrs: {
                                              placement: "bottom",
                                              trigger: "hover",
                                              "popper-class": "sop-popover",
                                              "visible-arrow": false
                                            }
                                          },
                                          [
                                            !item.disabled
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "sub-node" },
                                                  _vm._l(
                                                    item.subNodes,
                                                    function(subItem) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: subItem.subCode,
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.jumpSopNodeDetail(
                                                                item.code,
                                                                subItem.subCode,
                                                                item.name,
                                                                subItem.subName
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$store
                                                                  .getters.isZh
                                                                  ? subItem.subName
                                                                  : subItem.subEName
                                                              ) + "："
                                                            )
                                                          ]),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                subItem.count
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: { slot: "reference" },
                                                slot: "reference"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tab-guide-column"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tab-guide-common"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tab-guide-row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tab-guide-item",
                                                                class: {
                                                                  disabled:
                                                                    item.disabled
                                                                }
                                                              },
                                                              [
                                                                _vm.activeName ===
                                                                  "SI" ||
                                                                _vm.activeName ===
                                                                  "SE"
                                                                  ? _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticClass:
                                                                          "svg-common",
                                                                        staticStyle: {
                                                                          "margin-right":
                                                                            "0px"
                                                                        },
                                                                        attrs: {
                                                                          "icon-class":
                                                                            "sop-sea"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm.activeName ===
                                                                      "AI" ||
                                                                    _vm.activeName ===
                                                                      "AE"
                                                                  ? _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticClass:
                                                                          "svg-common",
                                                                        staticStyle: {
                                                                          "margin-right":
                                                                            "0px"
                                                                        },
                                                                        attrs: {
                                                                          "icon-class":
                                                                            "sop-air"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "svg-icon",
                                                                      {
                                                                        staticClass:
                                                                          "svg-common",
                                                                        staticStyle: {
                                                                          "margin-right":
                                                                            "0px"
                                                                        },
                                                                        attrs: {
                                                                          "icon-class":
                                                                            "sop-land"
                                                                        }
                                                                      }
                                                                    )
                                                              ],
                                                              1
                                                            ),
                                                            item.error
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "el-icon-warning"
                                                                })
                                                              : _vm._e(),
                                                            _c("div", {
                                                              staticClass:
                                                                "tab-guide-arrow"
                                                            })
                                                          ]
                                                        ),
                                                        item.name.length > 8
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tab-guide-name",
                                                                attrs: {
                                                                  title:
                                                                    item.copyName
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$store
                                                                      .getters
                                                                      .isZh
                                                                      ? item.name
                                                                      : item.eName
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "tab-guide-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$store
                                                                      .getters
                                                                      .isZh
                                                                      ? item.name
                                                                      : item.eName
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _c(
                                  "div",
                                  {
                                    key: index + _vm.rowDatas.length,
                                    staticClass: "arrow",
                                    class: [
                                      rowData.isOdd ? "tab-two" : "tab_three"
                                    ]
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "tab-guide-arrow tab-guide-arrow_right"
                                    })
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        ),
                        _c(
                          "div",
                          { staticClass: "sop-wrapper-bar" },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  margin: "0px 5px",
                                  color: "#1F75D5"
                                }
                              },
                              [_vm._v(_vm._s(_vm.defaultName))]
                            ),
                            _c(
                              "el-popover",
                              {
                                attrs: { placement: "bottom-end" },
                                model: {
                                  value: item.popVisible,
                                  callback: function($$v) {
                                    _vm.$set(item, "popVisible", $$v)
                                  },
                                  expression: "item.popVisible"
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      type: "primary"
                                    },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Message.SelectTemplate")
                                        ) +
                                        " "
                                    ),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                      staticStyle: { color: "#CCCCCC" }
                                    })
                                  ]
                                ),
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.templates,
                                      border: "",
                                      "row-class-name": _vm.onRowClassName
                                    }
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t("Template.TemplateName"),
                                        width: "150"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onTemplateClick(
                                                          row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(row.templateName) +
                                                        " (" +
                                                        _vm._s(row.nodeCount) +
                                                        ")"
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_DefaultOrNot"
                                        )
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-checkbox", {
                                                  attrs: {
                                                    value:
                                                      row.homepageDisplayOnUser
                                                  },
                                                  on: {
                                                    input: function(val) {
                                                      return _vm.onCheckInput(
                                                        item,
                                                        row,
                                                        val
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("div", { staticStyle: { clear: "both" } })
                ],
                2
              )
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }